export const ui_version = 'v2.5.0'
export const app_version = 'v2.0.0'




